import { getIcon } from "../../../../../../utils/get-icon";
import {
  Controller,
  ControllerWrapper,
  SeekButton,
  PlayButton,
  FullscreenButton,
  TimeWrapper,
  TimeDisplay,
} from "./styled";
import { PlayerRef } from "@remotion/player";
import { useVideoPreview } from "../../canvas/hooks/useVideoPreview";
import { useTimelineContext } from "../../remotion-timeline/context/use-timeline-context";
import { formatTime } from "../../../../../../utils/format-time";

interface Props {
  playerRef: React.RefObject<PlayerRef>;
}

const Controllers = ({ playerRef }: Props) => {
  const { durationInFrames } = useTimelineContext();
  const {
    seekBackward,
    seekForward,
    isPlaying,
    togglePlayPause,
    toggleFullscreen,
    currentTimeInSeconds,
    totalDurationInSeconds,
  } = useVideoPreview({ playerRef, durationInFrames });

  return (
    <ControllerWrapper>
      <Controller align="left">
        <TimeWrapper>
          <TimeDisplay active>{formatTime(currentTimeInSeconds)}</TimeDisplay>
          <TimeDisplay active={false}>
            /{formatTime(totalDurationInSeconds)}
          </TimeDisplay>
        </TimeWrapper>
      </Controller>
      <Controller align="center">
        <SeekButton onClick={seekBackward}>{getIcon("backward")}</SeekButton>
        <PlayButton onClick={togglePlayPause}>
          {isPlaying ? getIcon("pause") : getIcon("play")}
        </PlayButton>
        <SeekButton onClick={seekForward}>{getIcon("forward")}</SeekButton>
      </Controller>
      <Controller align="right">
        <FullscreenButton onClick={toggleFullscreen}>
          {getIcon("expand")}
        </FullscreenButton>
      </Controller>
    </ControllerWrapper>
  );
};

export default Controllers;
